import React from 'react'
import { ClosedEye, OpenEye } from '../../../assets/icons'
import {
	InputWrapper,
	Label,
	InputContainer,
	StyledInput,
	InputIconLeft,
	InputIconRight,
	ErrorMessage,
	HelperText,
	TextAreaContent,
	IconInputPassword
} from './styled'

const Input = ({
	width,
	height,
	maxWidth,
	minWidth,
	label,
	error,
	helperText,
	type = 'text',
	placeholder,
	value,
	onChange,
	isTextArea = false,
	disabled = false,
	required = false,
	id,
	name,
	marginBottom,
	fullWidth = false,
	startAdornment,
	endAdornment,
	icon,
	iconPosition = 'left',
	isPassword = false,
	...props
}) => {
	const inputId = id || name || `input-${Math.random()}`

	const hasCompatIcon = !!icon
	const leftNode = startAdornment ?? (hasCompatIcon && iconPosition === 'left' ? icon : null)
	const rightNode = endAdornment ?? (hasCompatIcon && iconPosition === 'right' ? icon : null)

	const hasLeft = !!leftNode
	const hasRight = !!rightNode
	const hasRightControl = hasRight || (isPassword && !isTextArea)
	const [showPassword, setShowPassword] = React.useState(false)

	const handleSeePaswordChange = () => {
		setShowPassword(prev => !prev)
	}
	const PasswordIcon = showPassword ? OpenEye : ClosedEye

	return (
		<InputWrapper $mb={marginBottom} fullWidth={fullWidth}>
			{label && (
				<Label htmlFor={inputId}>
					{label}
					{required && <span className="req">*</span>}
				</Label>
			)}
			<InputContainer width={width} maxWidth={maxWidth} minWidth={minWidth}>
				{hasLeft && (
					<InputIconLeft>{typeof leftNode === 'function' ? leftNode() : leftNode}</InputIconLeft>
				)}
				{!isTextArea ? (
					<>
						<StyledInput
							width={width}
							height={height}
							maxWidth={maxWidth}
							minWidth={minWidth}
							id={inputId}
							name={name}
							type={isPassword ? (showPassword ? 'text' : 'password') : type}
							placeholder={placeholder}
							value={value}
							onChange={onChange}
							disabled={disabled}
							$error={!!error}
							$hasLeft={hasLeft}
							$hasRight={hasRightControl}
							style={fullWidth ? { maxWidth: '100%' } : {}}
							{...props}
						/>
						{isPassword && (
							<IconInputPassword>
								<div
									onClick={() => handleSeePaswordChange()}
									role="button"
									tabIndex={0}
									onKeyDown={(e) => {
										if (e.key === 'Enter' || e.key === ' ') {
											e.preventDefault()
											handleSeePaswordChange()
										}
									}}
								>
									<PasswordIcon />
								</div>
							</IconInputPassword>)}
					</>
				) : (
					<TextAreaContent
						width={width}
						height={height}
						maxWidth={maxWidth}
						minWidth={minWidth}
						id={inputId}
						name={name}
						type={type}
						placeholder={placeholder}
						value={value}
						onChange={onChange}
						disabled={disabled}
						$error={!!error}
						$hasLeft={hasLeft}
						$hasRight={hasRightControl}
						style={fullWidth ? { maxWidth: '100%' } : {}}
						{...props}
					/>
				)}
				{hasRight && (
					<InputIconRight>
						{typeof rightNode === 'function' ? rightNode() : rightNode}
					</InputIconRight>
				)}
			</InputContainer>
			{error ? (
				<ErrorMessage>{error}</ErrorMessage>
			) : helperText ? (
				<HelperText>{helperText}</HelperText>
			) : null}
		</InputWrapper>
	)
}

export default Input
